import dialogImage from './assets/site-centric-dialog.webp';

let preloadedSiteCentricNavConfirmDialogImage: Promise<void> | undefined;
let siteCentricNavConfirmDialogPreloadLink: HTMLLinkElement | undefined;

/**
 * URL for the site-centric navigation confirmation dialog preview image.
 */
export const siteCentricNavConfirmDialogImage = dialogImage;

/**
 * Preload the site-centric navigation confirmation dialog preview image.
 */
export function preloadSiteCentricNavConfirmDialogImage(): Promise<void> {
    ensureSiteCentricNavConfirmDialogPreloadLink();

    if (preloadedSiteCentricNavConfirmDialogImage) {
        return preloadedSiteCentricNavConfirmDialogImage;
    }

    preloadedSiteCentricNavConfirmDialogImage = new Promise((resolve) => {
        const image = new Image();
        const resolveDecoded = () => {
            const decodePromise =
                typeof image.decode === 'function' ? image.decode() : Promise.resolve();
            void decodePromise.catch(() => undefined).then(() => resolve());
        };

        image.onload = resolveDecoded;
        image.onerror = () => resolve();
        image.src = siteCentricNavConfirmDialogImage;

        if (image.complete) {
            resolveDecoded();
        }
    });

    return preloadedSiteCentricNavConfirmDialogImage;
}

function ensureSiteCentricNavConfirmDialogPreloadLink() {
    if (siteCentricNavConfirmDialogPreloadLink || typeof document === 'undefined') {
        return;
    }

    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = siteCentricNavConfirmDialogImage;
    link.fetchPriority = 'high';

    document.head.appendChild(link);
    siteCentricNavConfirmDialogPreloadLink = link;
}
